import { makeAutoObservable, runInAction } from 'mobx';
import { token } from '@/infrastructure/container';
import { type IAppBus } from '@/services/AppBus';
import { type IIdGen } from '@/services/IdGen';

export interface Toast {
  id: string;
  kind: 'success' | 'error' | 'info';
  message: string;
}

export class ToastStore {
  private _toasts: Toast[] = [];

  constructor(bus: IAppBus, private idGen: IIdGen) {
    makeAutoObservable(this);
    bus.subscribe('TOAST_REQUESTED', this.onToastRequested);
  }

  get toasts(): readonly Toast[] {
    return this._toasts;
  }

  dismiss = (id: string): void => {
    this._toasts = this._toasts.filter((t) => t.id !== id);
  };

  private onToastRequested = (data: { kind: Toast['kind']; message: string }): void => {
    const toast: Toast = { id: this.idGen.next(), kind: data.kind, message: data.message };
    this._toasts = [...this._toasts, toast];
    // runInAction needed: callback fires outside any store method, so MobX wouldn't track this
    // mutation as an action otherwise. INVARIANTS rule 14.
    setTimeout(() => {
      runInAction(() => {
        this._toasts = this._toasts.filter((t) => t.id !== toast.id);
      });
    }, 3500);
  };
}

export const TOKEN_ToastStore = token<ToastStore>('ToastStore');
